import { Component, Input, OnInit } from '@angular/core';
import { NoteRating } from '../../types/note_rating';
import { UserService } from '../../services/user_service';

@Component({
  selector: 'app-note-rating',
  templateUrl: './note-rating.component.html',
  styleUrls: ['./note-rating.component.scss']
})
export class NoteRatingComponent {
  @Input()
  public noteRating: NoteRating;

  constructor(private userService: UserService) { }
}
